export function getParameterByName(name: string, url: string) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function toQueryString(obj: any) {
  return Object.entries(obj).reduce((acc,[key,val])=>{
    if(Array.isArray(val)){
      val.forEach(e=>acc += (acc ? "&": "") + key + "=" + e);
    } else {
      acc += (acc ? "&": "") + key + "=" + val;
    }
    return acc;
  }, "");
}

export function getHashParams() {
  const href = window.location.href;
  const params = href.split('#')[1];

  // Be sure url params exist
    if (params && params !== '') {
      const retVal = params.split('&').reduce(function (res, item) {
        const parts = item.split('=');
        // @ts-ignore
        res[parts[0]] = parts[1];
        return res;
      }, {});
      return retVal;
    }
    return {}
}

export function setQueryParams(newQueryParams: string[]) {
  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + newQueryParams.join('&');
  window.history.pushState({path:newurl},'', newurl);
}

export function addOrReplaceQueryParam(key: string, value: string) {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set(key, value);

  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + queryParams.toString();
  window.history.pushState({path:newurl},'', newurl);
}

export function deleteQueryParam(key: string) {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete(key);

  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + queryParams.toString();
  window.history.pushState({path:newurl},'', newurl);
}

function redirectWithQueryParams(url: string) {
  const queryParams = new URLSearchParams(window.location.search);
  window.location.href = `${url}?${queryParams.toString()}`
}

export function clearLastPath() {
  localStorage.removeItem('lastPath');
}

export function updateLastPath(pathname: string) {
  if (localStorage.getItem('lastPath') !== pathname) {
    localStorage.setItem('lastPath', pathname);
  }
}

export function getLastPath(fallBack: string): string {
  return localStorage.getItem('lastPath') ?? fallBack;
}

const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

/**
 * Remember an internal deep link the user requested while logged out, so we can send them
 * back to it once they authenticate. Only stores safe, in-app paths (guards against
 * open-redirects / protocol-relative URLs).
 */
export function setPostLoginRedirect(path: string) {
  if (path && path.startsWith('/') && !path.startsWith('//')) {
    localStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  }
}

/** Read and clear the remembered post-login redirect (consume-once). */
export function consumePostLoginRedirect(): string | null {
  const path = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  if (path) {
    localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  }
  return path;
}
